<template>
  <form action="">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Вход</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Логин">
          <b-input
          type="text"
          v-model="username"
          placeholder="Ваш логин"
          required>
        </b-input>
      </b-field>

      <b-field label="Пароль">
        <b-input
        type="password"
        v-model="password"
        password-reveal
        placeholder="Ваш пароль"
        required>
      </b-input>
    </b-field>

    <!-- <b-checkbox>Remember me</b-checkbox> -->

  </section>
  <footer class="modal-card-foot">
    <button class="button is-primary" @click='sign_in(username, password)'>Войти</button>
  </footer>
</div>
</form>
</template>

<script>
export default {
  props: ['login_method', 'error', 'success'],
  data: function () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    sign_in: function (username, password) {
      if ((username === '') || (password === '')) return
      var t = this
      var form = JSON.stringify({method: 'login', params: {username: username, password: password}})
      window.$.post(window.gw + 'api/user', {data: form}, function (r) {
        var d = JSON.parse(r)
        if (d.result === 'ok') {
          t.success()
          t.$parent.close()
        }
        if (d.result === 'error') {
          t.$toast.open({
            duration: 5000,
            message: d.params.msg,
            position: 'is-bottom',
            type: 'is-danger'
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.modal-card {
  width: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/loginFormModal.vue